// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** list GET /official_document/log/list */
export async function getOfficialDocumentLogList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getOfficialDocumentLogListParams,
  options?: { [key: string]: any },
) {
  return request<API.SPageC2ABOfficialDocumentRunLogVoC2BB>('/official_document/log/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
